module.exports = __webpack_public_path__ + "img/shield.90e386b8.png";